export const toAbsoluteUrl = (pathname: string) =>
  process.env.REACT_APP_PUBLIC_URL + pathname;
